import { render, staticRenderFns } from "./Reg_selectAge.vue?vue&type=template&id=6bfba3da&scoped=true"
import script from "./Reg_selectAge.vue?vue&type=script&lang=js"
export * from "./Reg_selectAge.vue?vue&type=script&lang=js"
import style0 from "./Reg_selectAge.vue?vue&type=style&index=0&id=6bfba3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfba3da",
  null
  
)

export default component.exports